import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import FormItem from 'components/form/FormItem';
import Checkbox from 'components/global/Checkbox';

import useAlert from 'hooks/useAlert';

import { setLoading } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';
import { PAYMENT_GATEWAY_TYPE } from 'utils/constants';

import * as S from './Tap.styled';

let popup;
export let tapPaymentToken = null;

const TapIframe = ({ subscription, setIsIframeLoaded, setInputsValid, paymentGatewayType: paymentGatewayTypeProp }) => {
	const { paymentGatewayType } = useSelector((state) => state?.user.localization) || paymentGatewayTypeProp;
	const formMethods = useFormContext();
	const { setValue, watch } = formMethods;
	const dispatch = useDispatch();
	const { showError } = useAlert();

	const { darkMode, localization } = useSelector((state) => state?.layout);
	const isRtl = localization?.dir === 'rtl';

	const [scriptLoaded, setScriptLoaded] = useState(false);

	const loadScript = (src, position, id) => {
		if (!position) {
			return;
		}

		const script = document.createElement('script');
		script.id = 'tap-payment-script';
		script.onload = () => {
			if (id === 'TapPayment') {
				setScriptLoaded(true);
			}
		};

		script.setAttribute('type', 'text/javascript');
		script.setAttribute('id', id);
		script.src = src;

		position.appendChild(script);
	};

	useEffect(() => {
		if (!window.CardSDK) {
			loadScript('https://tap-sdks.b-cdn.net/card/1.0.2/index.js', document.querySelector('head'), 'TapPayment');
		} else {
			setScriptLoaded(true);
		}
	}, []);

	useEffect(() => {
		if (!scriptLoaded) return;

		const { renderTapCard, Theme, Currencies, Direction, Edges, Locale } = window.CardSDK;
		const { unmount } = renderTapCard('card-sdk-id', {
			publicKey:
				paymentGatewayType === PAYMENT_GATEWAY_TYPE.TAP_PAYMENT_UAE
					? import.meta.env.VITE_TAP_PAYMENT_UAE_API_KEY
					: import.meta.env.VITE_TAP_PAYMENT_API_KEY,
			merchant: {
				id:
					paymentGatewayType === PAYMENT_GATEWAY_TYPE.TAP_PAYMENT_UAE
						? import.meta.env.VITE_TAP_PAYMENT_UAE_MERCHANT_ID
						: import.meta.env.VITE_TAP_PAYMENT_MERCHANT_ID
			},
			transaction: {
				currency: paymentGatewayType === PAYMENT_GATEWAY_TYPE.TAP_PAYMENT_UAE ? Currencies.AED : Currencies.SAR
			},
			acceptance: {
				supportedBrands: ['AMERICAN_EXPRESS', 'VISA', 'MASTERCARD', 'MADA'], // Remove the ones that are NOT enabled on your Tap account
				supportedCards: 'ALL' // To accept both Debit and Credit
			},
			fields: {
				cardHolder: true
			},
			addons: {
				displayPaymentBrands: true,
				loader: true,
				saveCard: false
			},
			interface: {
				locale: isRtl ? Locale.AR : Locale.EN,
				theme: darkMode ? Theme.DARK : Theme.LIGHT,
				edges: Edges.STRAIGHT,
				direction: isRtl ? Direction.RTL : Direction.LTR
			},
			onReady: () => {
				setIsIframeLoaded?.(true);
			},
			onValidInput: (status) => {
				setInputsValid?.(status);
			},
			onError: (data) => {
				popup?.close();
				showError();
				AppLogger.error(data);
				dispatch(setLoading(false));
				window.dispatchEvent(new Event('tapPaymentTokenError'));
			},
			onSuccess: (data) => {
				tapPaymentToken = data.id;
				window.dispatchEvent(new Event('tapPaymentTokenCreated'));
			}
		});

		return () => {
			unmount?.();
		};
	}, [scriptLoaded]);

	return (
		<>
			<S.Wrapper id="card-sdk-id" />
			{!subscription && (
				<div onClick={() => setValue('saveCard', !watch('saveCard'))}>
					<FormItem label="saveCardForFuturePayments" direction="row-reverse">
						<Checkbox checked={watch('saveCard')} readOnly />
					</FormItem>
				</div>
			)}
		</>
	);
};

export default TapIframe;
